export default "__VITE_ASSET__DszovipA__"